// extracted by mini-css-extract-plugin
export default {"modalActions":"vat-edit-modal_modalActions__QHyZm"};